import React, { Children } from 'react';
import { __assign } from '../_virtual/_tslib.js';

var ExperimentContext = React.createContext({
    treatment: function () { return ({
        treatment: 'control',
        promise: Promise.resolve('control'),
        active: Promise.resolve(true),
        changeNumber: Promise.resolve(-1)
    }); }
});
var ExperimentProviderConsumer = ExperimentContext.Consumer;
var ExperimentClientProvider = function (_a) {
    var children = _a.children, experimentClient = _a.experimentClient, id = _a.id, defaultAttributes = _a.attributes, defaultOptions = _a.options;
    var identifiedExperimentClient = {
        treatment: function (_a) {
            var experiment = _a.experiment, attributes = _a.attributes, options = _a.options, defaultTreatment = _a.defaultTreatment, overrideId = _a.overrideId;
            return experimentClient.treatment({
                id: overrideId || id,
                experiment: experiment,
                attributes: __assign(__assign({}, defaultAttributes), attributes),
                defaultTreatment: defaultTreatment,
                options: __assign(__assign({}, defaultOptions), options)
            });
        }
    };
    return (React.createElement(ExperimentContext.Provider, { value: identifiedExperimentClient }, Children.only(children)));
};

export { ExperimentClientProvider, ExperimentContext, ExperimentProviderConsumer };
//# sourceMappingURL=ExperimentClient.js.map
